var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2020_231631)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8964 5.29289C13.2871 4.90237 13.9206 4.90237 14.3112 5.29289L19.9601 10.9393C20.5461 11.5251 20.5461 12.4749 19.9601 13.0607L14.3112 18.7071C13.9206 19.0976 13.2871 19.0976 12.8964 18.7071C12.5057 18.3166 12.5057 17.6834 12.8964 17.2929L17.1911 13H4.60003C4.04751 13 3.59961 12.5523 3.59961 12C3.59961 11.4477 4.04751 11 4.60003 11H17.1911L12.8964 6.70711C12.5057 6.31658 12.5057 5.68342 12.8964 5.29289Z",
    fill: "#006B6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2020_231631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowForward);
export default __webpack_public_path__ + "static/media/ic_arrow-forward.ccc1bf31af296f93198f72289e85e6ab.svg";
export { ForwardRef as ReactComponent };